import {styled} from '@linaria/react';
import {COLORS} from '../../../constants/colors';

export const ProductTileWrapper = styled.div`
  contain: content;
  background: ${COLORS.White};

  &[data-enable-containment='true'] {
    contain: size layout paint style;
    contain-intrinsic-size: var(--tile-height);
    content-visibility: auto;
    will-change: auto;
  }
`;
